const updateAuthActionsAction = (payload) => {
  // console.log(payload);
  return { type: "AUTH_VERIFY", payload: payload };
};

export default updateAuthActionsAction;
